import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

const API_URL = `${environment.apiUrl}/api/planillas`;

export interface Planilla {
  contratoNumero?: string;
  idfuec?: number;
  nfuec?: string;
  empresa?: string;
  nite?: string;
  contrato?: number;
  contratista?: string;
  nitc?: number;
  objeto?: string;
  ruta?: string;
  terceros?: string;
  ut?: boolean;
  conv?: boolean;
  consor?: boolean;
  finicial?: Date;
  ffinal?: Date;
  origen?: string;
  destino?: string;
  placa?: string;
  modelo?: string;
  marca?: string;
  clase?: string;
  interno?: string;
  operaciones?: number;
  conductor?: string;
  cedula?: string;
  licencia?: string;
  vigencia?: Date;
  conductor1?: string;
  cedula1?: string;
  licencia1?: string;
  vigencia1?: Date;
  conductor2?: string;
  cedula2?: string;
  licencia2?: string;
  vigencia2?: Date;
  idresponsable?: number;
  responsable?: string;
  telefonor?: number;
  direccionr?: string;
  direccion?: string;
  telefono?: number;
  email?: string;
  web?: string;
  usuario?: string;
  viaje?: string;
  estado?: string;
  ip?: string;
  disponibilidad?: boolean;
  complemento?: string;
}

@Injectable({
  providedIn: "root",
})
export class PlanillaService {
  constructor(private http: HttpClient) {}

  getAllPlanillas(): Observable<any> {
    return this.http.get(API_URL, { withCredentials: true });
  }

  getPlanillaById(id: number): Observable<any> {
    return this.http.get(`${API_URL}/${id}`, { withCredentials: true });
  }

  createPlanilla(data: any): Observable<any> {
    return this.http.post(API_URL, data, { withCredentials: true });
  }

  updatePlanilla(idfuec: string, data: any): Observable<any> {
    return this.http.put(`${API_URL}/${idfuec}`, data, { withCredentials: true });
  }

  getPlanillasByEstado(estado: "1" | "-1"): Observable<any> {
    return this.http.get(`${API_URL}/estado?estado=${estado}`, { withCredentials: true });
  }

  getPlanillaPorNumero(numero: string): Observable<any> {
    return this.http.get(`${API_URL}/por-numero/${numero}`, { withCredentials: true });
  }

getContarPlanillasPorMes(): Observable<any> {
  return this.http.get(`${API_URL}/conteo-extracto`, { withCredentials: true });
}

  inactivarPlanilla(idfuec: string): Observable<any> {
    return this.http.put(
      `${API_URL}/inactivar/${idfuec}`,
      { estado: 0 },
      { withCredentials: true }
    );
  }

  buscarPlanillasPorFiltros(
    objeto?: string,
    placa?: string,
    finicial?: Date,
    ffinal?: Date
  ): Observable<{ planillas: Planilla[], mensaje: string }> {
    const body: any = {};
    if (objeto) body.objeto = objeto;
    if (placa) body.placa = placa;
    if (finicial) body.finicial = finicial;
    if (ffinal) body.ffinal = ffinal;

    return this.http.post<{ planillas: Planilla[], mensaje: string }>(
      `${API_URL}/buscar`,
      body,
      { withCredentials: true }
    );
  }
}
